import { Link } from 'react-router-dom';
import type { Movie } from '../../mocks/movies';
import { formatViews } from '../../utils/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title}中文字幕在线观看`}
          title={`${movie.title} - 高清中文字幕`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[11px] font-medium">
            {movie.type === 'movie' ? '电影' : '剧集'}
          </span>
        </div>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-secondary-950 text-[11px] font-bold">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 w-11 h-11 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
          <i className="ri-play-fill text-xl" aria-hidden="true"></i>
        </div>
      </div>
      <div className="p-3 md:p-4 flex flex-col gap-1.5">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 truncate">
          {movie.genres.join(' · ')} · {movie.year}
        </p>
        <div className="flex items-center justify-between mt-1 text-[11px] text-foreground-400">
          <span className="truncate">{movie.region}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
            {formatViews(movie.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}